import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

export const FAQ = () => {
   const { t } = useTranslation();
   return (
      <Box sx={{ padding: '2rem' }}>
         <Typography variant="h4" gutterBottom mt={3}>
            {t('faq.title')}
         </Typography>

         <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{t('faq.dresscode.title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>{t('faq.dresscode.content')}</Typography>
            </AccordionDetails>
         </Accordion>

         <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{t('faq.carpool.title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>{t('faq.carpool.content')}</Typography>
            </AccordionDetails>
         </Accordion>

         <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{t('faq.edit.title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>{t('faq.edit.content')}</Typography>
            </AccordionDetails>
         </Accordion>

         <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{t('faq.language.title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>{t('faq.language.content')}</Typography>
            </AccordionDetails>
         </Accordion>

         <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{t('faq.children.title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>{t('faq.children.content')}</Typography>
            </AccordionDetails>
         </Accordion>

         <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
               <Typography>{t('faq.gift.title')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
               <Typography>{t('faq.gift.content')}</Typography>
            </AccordionDetails>
         </Accordion>
      </Box>
   );
};
